import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import i18nInit from "./i18n/i18nInit";
import nexo from "./nexoClient";
import { iAmReady, connect, getStoreInfo, getCurrentPathname } from "./libs/nexo/helpers";
import { useStore } from "./StoreContext";

interface InitialProps {
  children: React.ReactNode;
}

i18nInit();

function Initial({ children }: InitialProps) {
  const t = useTranslation();
  const [initial, setInitial] = useState(false);
  const { setStore } = useStore();

  useEffect(() => {
    connect(nexo).then(async () => {
      const pathname = await getCurrentPathname(nexo);

      // if (pathname && window.location.pathname !== pathname) {
      //   window.location.href = pathname;
      //   return;
      // }

      if (pathname && window.location.hash !== '#' + pathname) {
        window.location.replace(process.env.PUBLIC_URL + '/#' + pathname);
        if (process.env.NODE_ENV === 'production') {
          window.location.reload();
        }
        return;
      }

      const storeInfo = await getStoreInfo(nexo);
      setStore(storeInfo);

      t.i18n.changeLanguage(`${storeInfo.language}-${storeInfo.country}`);

      setInitial(true);
      iAmReady(nexo);
    }).catch(() => {
      console.error('nexo does not respond');
    });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!initial) {
    return null;
  }

  return <>{children}</>;
}

export default Initial;
